import { useState, useRef } from 'react';
import { apiurl } from '../../common/constants';
import { useAuthAxios } from '../authfetch';
import { useStore } from '../../context/StoreContext';
import { CategoryWithSubCategorySelect } from "../subcomponents/Selectors";
import EditCategory from './EditCategory';

const AddCategory = ({ updates, setUpdates }) => {
  const { categories } = useStore();
  const authAxios = useAuthAxios();
  
  // States for forms
  const [newCategoryName, setNewCategoryName] = useState('');
  const [newSubCategoryName, setNewSubCategoryName] = useState('');
  const [selectedMainCategory, setSelectedMainCategory] = useState('Select MainCategory');

  const categoryFormRef = useRef(null);
  const subCategoryFormRef = useRef(null);

  const handleAddCategory = async (e) => {
    e.preventDefault();
    if (!categoryFormRef.current.checkValidity()) {
        categoryFormRef.current.reportValidity();
      return;
    }

    let formattedName = newCategoryName.trim();
    formattedName = formattedName.charAt(0).toUpperCase() + formattedName.slice(1);

    try {
      const { data } = await authAxios.post(`${apiurl}/categories`, { 
        "category_name": formattedName 
      });
      if (data.status === "ok") {
        alert(`[ok] ${data.message}`);
        setUpdates(prev => ({...prev, categoryUpdates: prev.categoryUpdates + 1}));
        setNewCategoryName('');
      } else {
        alert(`[error] ${data.message}`);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleAddSubCategory = async (e) => {
    e.preventDefault();
    if (!subCategoryFormRef.current.checkValidity()) {
        subCategoryFormRef.current.reportValidity();
      return;
    }

    let formattedName = newSubCategoryName.trim();
    formattedName = formattedName.charAt(0).toUpperCase() + formattedName.slice(1);

    if (selectedMainCategory === "Select MainCategory") {
      alert("select MainCategory before creating SubCategory!");
      return;
    }

    try {
      const { data } = await authAxios.post(`${apiurl}/categories`, { 
        "subcategory_name": formattedName, 
        "category_ref": selectedMainCategory.slice(1,) 
      });
      if (data.status === "ok") {
        alert(`[ok] ${data.message}`);
        setUpdates(prev => ({...prev, categoryUpdates: prev.categoryUpdates + 1}));
        setNewSubCategoryName('');
      } else {
        alert(`[error] ${data.message}`);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleSelectChange = (val) => {
    setSelectedMainCategory(val);
  }

  return (
    <div>
        <div className="note"><strong>Note:</strong> <strong>CategoryType</strong> cannot be change once created (<strong>MainCategory</strong> can't be changed to <strong>SubCategory</strong> and vice versa). Create Carefully!</div>
      <form className='addCategoryForm' ref={categoryFormRef}>
        <div className="input-group mb-3">
          <span className="input-group-text">MainCategory Name</span>
          <input 
            type="text" 
            required 
            className="form-control" 
            placeholder="New Category Name" 
            value={newCategoryName}
            onChange={(e) => setNewCategoryName(e.target.value)}
          />
        </div>
        <button className="btn btn-primary" onClick={handleAddCategory}>Add Category</button>
        <button type="button" className="btn btn-success mx-4" data-bs-toggle="modal" data-bs-target="#editCategory">
          Edit Category/SubCategory
        </button>
      </form>
      <hr className='my-4' />

      <form className='addSubCategoryForm mt-3' ref={subCategoryFormRef}>
        <div className="input-group mb-3">
          <span className="input-group-text">SubCategory Name</span>
          <input 
            type="text" 
            required 
            className="form-control" 
            placeholder="New SubCategory Name" 
            value={newSubCategoryName}
            onChange={(e) => setNewSubCategoryName(e.target.value)}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text">SubCategory Of</span>
          <CategoryWithSubCategorySelect
            categories={categories}
            firstOption="Select MainCategory"
            disableFirstOption={true}
            disableSubCategory={true}
            isRequired={true}
            selectId="addSubcategorySelect" 
            onChange={handleSelectChange} 
          />

        </div>
        <button className="btn btn-primary" onClick={handleAddSubCategory}>Add SubCategory</button>

      </form>

      <EditCategory categories={categories} updates={updates} setUpdates={setUpdates} />
    </div>
  );
};

export default AddCategory;
